import { combineReducers } from 'redux'

import * as actionsTypes from './AudioPlayer/actionsNames'
import playQueue from './playqueueReducers'
import * as constants from './AudioPlayer/playerConstants'

const settingsInitialState = {
	volume: 100,
	muted: false,
	loopmode: constants.LOOP_MODE.noRepeat,
	shuffled: false,
	fullplayer: false,
	playqueueVisibility: false,
	initialSeek: 0
}
const playerSettings = (state = settingsInitialState, action) => {
	switch (action.type) {
		case actionsTypes.SET_FROM_STORAGE:
			return state
		case actionsTypes.SET_SEEK:
			return {
				...state,
				initialSeek: action.seek
			}
		default:
			return state
	}
}

const playingInitialState = {
	loaded: false,
	playing: false,
	buffering: false,
	buffers: [],
	seek: 0,
	currentGetFileUrl: null
}
const playingInfo = (state = playingInitialState, action) => {
	switch (action.type) {
		case actionsTypes.SET_LOADED:
			return {
				...state,
				loaded: action.loaded
			}
		case actionsTypes.SET_PLAYING:
			return {
				...state,
				playing: action.playing
			}
		case actionsTypes.SET_BUFFERING:
			return {
				...state,
				buffering: action.buffering
			}
		case actionsTypes.SET_BUFFERS:
			return {
				...state,
				buffers: action.buffers
			}
		case actionsTypes.SET_SEEK:
			return {
				...state,
				seek: action.seek
			}
		case actionsTypes.SET_CURRENT_GETFILEURL:
			return {
				...state,
				currentGetFileUrl: action.getFileUrl
			}
		default:
			return state
	}
}


export default combineReducers({
	playerSettings,
	playingInfo,
	playQueue
})



// WEBPACK FOOTER //
// ./src/components/miniPlayer/miniPlayerReducers.js